import {
  ITierPattern,
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";

export function getContainersByTier(
  tierPattern: ITierPattern,
): (smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock) => TGetContainersFilterOutput {
  return (smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock): TGetContainersFilterOutput => {
    const containers: TIContainerInformationExtendedValid[] = [];

    const { gridContent, allStacksKeys } = smartBay.getGridContent();

    // For each stack, get the container at the specified tier
    for (const stackKey of allStacksKeys) {
      const content = gridContent[stackKey]?.[tierPattern];
      if (content) {
        containers.push(...(content.containers as TIContainerInformationExtendedValid[]));
      }
    }

    return {
      containers,
      tBaysStr: smartBay.tBaysStr,
      level: smartBay.level,
    };
  };
}
